<template>
  <div class="normal-toggle-chart">
    <basic-container>
      <div class="header__date" flex="cross:center">
        <div
          v-for="(item,index) in tooggleDate"
          :key="index"
          class="header__date-row"
          flex="cross:center"
          :class="tooggleDateIndex === index?'header__date-row--active':''"
          @click="onHandleToggleDate(item,index)"
        >{{item}}</div>
      </div>

      <ve-histogram :data="chartData" :settings="chartSettings" legend-position="bottom"></ve-histogram>

      <!-- <div>
        <div>
          <div>微信:0.99% | 3</div>
        </div>
      </div>-->
    </basic-container>
  </div>
</template>

<script>
import BasicContainer from "@vue-materials/basic-container";
import VeHistogram from "v-charts/lib/histogram";

export default {
  components: { BasicContainer, VeHistogram },
  name: "PayAccessChart",
  data() {
    this.chartSettings = {
      // offsetY: 150,
      // label: {
      //   show: true,
      //   position: "outside"
      // }
    };
    return {
      tooggleDateIndex: 0,
      tooggleDate: ["提现成功", "提现失败"],

      chartData: {
        columns: ["日期", "金额", "数量"],
        rows: [
        ]
      }
    };
  },
  methods: {
    onHandleToggleDate(item, index) {
      this.tooggleDateIndex = index;
      if(index==1){
          console.info("=====index===="+index);
          this.$emit('refreshgetTableData');
      }else{
          this.$emit('refreshgetTableData2');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  &__date {
    display: inline-block;
    height: 30px;
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
  &__date-row {
    padding: 0 0.2rem;
    height: 30px;
    float: left;
    font-size: 14px;
  }
  &__date-row--active {
    background-color: #409eff !important;
    color: #fff;
  }
  &__date-row:not(:last-child) {
    border-right: 1px solid #dcdfe6;
  }
}
</style>
